export default {"src":"/_next/static/media/initial-assessment.baa527a7.svg","height":305,"width":274,"blurWidth":0,"blurHeight":0};